import { render, staticRenderFns } from "./badge-icon.vue?vue&type=template&id=0951263e&"
import script from "./badge-icon.vue?vue&type=script&lang=js&"
export * from "./badge-icon.vue?vue&type=script&lang=js&"
import style0 from "./badge-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports